import styles from "./Wishlist.module.scss";
import Srcset from "@/components/common/Srcset";
import { encryptOrDecrypt } from "@/helpers/generalHelper";

//OS-3215: See wishlist as a PLP

export default function ShareWishlist(props) {
  const { handleShareWishlist, custId, parentClass,wishlistHashId } = props;
  const data = {
    customerId : custId,
    wishlistHashId : wishlistHashId
  }

  //generating encrypted object using data object above
  let encryptedId = encryptOrDecrypt(data)

  const link = process.env.NETLIFY_URL + "/wishlist/" + encryptedId

  const handleButtonClick = (e) => {
    if(e.target.innerText === "Copy link"){
        navigator.clipboard.writeText(link)
        document.getElementById("copyButton").innerText = "Copied"
        setTimeout(() => document.getElementById("copyButton").innerText = "Copy link", 3000)
    }
  }

    return (
        <div>
            <div className={`${styles.account_back}`}>
                <a onClick={() => { handleShareWishlist(false) }}>
                    <Srcset
                        requirePath={true}
                        svgFile={true}
                        className={'back_icon'}
                        src={"images/Icons/Arrow/Right/large.svg?imbypass=true"}
                        alt="back button"
                        height="16"
                        width="19.11"
                        tabIndex={0}
                    />
                </a>
            </div>
            <div className={`${styles.card} ${parentClass}`}>
                <div className={`${styles.card_title} x-large-xs xx-large-sm xx-large-md light`}>Share wishlist</div>
            <div className={`${styles.card_body}`}>
                <p className={`${styles.card_message} x-small-xs x-small-sm small-md `}>Use this link to share your wishlist with family and friends.</p>
                <div className={`${styles.card_link} x-small-xs xx-small-sm x-small-md`}>{link}</div>
            </div>
            <button id="copyButton" className={`${styles.button} btn-primary ga-share-wishlist`} onClick={handleButtonClick}>
                Copy link
            </button>       
        </div>
    </div>
  );
}
